import { createSlice } from "@reduxjs/toolkit";
import { format } from "date-fns";

const date = new Date();
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 1);
const lastDay = new Date(
  date.getFullYear(),
  date.getMonth(),
  date.getDate(),
  1,
);

const initialState = () => ({
  date_start: format(firstDay, "yyyy-MM-dd"),
  date_end: format(lastDay, "yyyy-MM-dd"),
  status_tipo: "QUEIMA_CAIXA",
  xprod: "",
  ncm: "",
  categorias: [],
});

export const queimaRiscoCategoriasSlice = createSlice({
  name: "queimaRiscoCategorias",
  initialState,
  reducers: {
    handleChangePeriodo: (state, { payload }) => {
      if (payload?.date_start) state.date_start = payload.date_start;
      if (payload?.date_end) state.date_end = payload.date_end;
    },
    handleChangeStatusTipo: (state, { payload }) => {
      state.status_tipo = payload;
    },
    handleChangeXprod: (state, { payload }) => {
      state.xprod = payload ?? "";
    },
    handleChangeCategorias: (state, { payload }) => {
      state.categorias = payload ?? [];
    },
    handleChangeNcm: (state, { payload }) => {
      state.ncm = payload ?? "";
    },
  },
});

export const {
  handleChangePeriodo,
  handleChangeStatusTipo,
  handleChangeXprod,
  handleChangeCategorias,
  handleChangeNcm,
} = queimaRiscoCategoriasSlice.actions;

export default queimaRiscoCategoriasSlice.reducer;
